<ion-content min="0" max="2400" color="white" class="ion-padding profile modal">
  <!--div class="ion-padding profile__picture">
    img [src]="service?.avatar?.document?.fileName | ppImage">
  </div-->

  <ion-button fill="clear" style="margin-right:0px;" class="ion-float-right" (click)="onCancel()">
    <ion-icon name="close" mode="md"></ion-icon>
  </ion-button>


  <div class="ion-padding profile__info" style="padding-bottom:0px; ">

    <h1 style="margin-top:15px;">{{ 'CONTACT_US.TITLE' | translate: { limit: (limit - 1) } }}</h1>

    <!--h2>{{ service.shortDescription | ppTranslate:service.longDescriptionTranslations:translateService.currentLang }}</h2-->
    <p>{{ 'CONTACT_US.INSTRUCTIONS' | translate }}</p>
    
    <p *ngIf="real.email" ><a href="mailto:{{ real.email }}">{{ real.email }}</a> </p>
    <p *ngIf="real.phone1"><a href="tel:{{ real.phone1 }}">{{ real.phone1 || '' | nationalFormat : 'SI' }}</a> </p>

  </div>

  <div class="ion-float-left clickable" style="margin-top:36px;">
    <a (click)="onCancel()"  class="pp-link">{{ 'CONTACT_US.CLOSE' | translate }}</a>
  </div>

  

</ion-content>